import { apiAddress } from '../ApiPlatform';

export const API_SELECT_QUESTION_LIST = apiAddress + '/question/select';
export const API_UPDATE_QEUSTION_REPLY = apiAddress + '/question/updateReply';
export const API_INSERT_QUESTION = apiAddress + '/question/insert';
export const API_SELECT_QUESTION_LIST_WITH_KEYWORD =
  apiAddress + '/question/selectKeyword';
